import { type HTMLAttributes } from "react";
import { cn } from "./utils/cn";

export interface PriceGridRow {
  taskType: string;
  builderRate: string; // e.g., "$0.04" or "TBD"
  humanPayout: string;
  networkFeePct: string;
}

export interface PriceGridProps extends HTMLAttributes<HTMLDivElement> {
  rows: PriceGridRow[];
}

const isTbd = (v: string) => v.trim().toUpperCase() === "TBD";

export const PriceGrid = ({ rows, className, ...rest }: PriceGridProps) => (
  <div className={cn("hui-price-grid", className)} {...rest}>
    <table className="hui-price-grid__table">
      <thead>
        <tr>
          <th>Task type</th>
          <th>Per label (Builder)</th>
          <th>Per label (Human)</th>
          <th>Network fee</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, idx) => (
          <tr key={`${r.taskType}-${idx}`}>
            <td>{r.taskType}</td>
            <td
              className={cn(
                "hui-price-grid__cell",
                isTbd(r.builderRate) && "hui-price-grid__cell--tbd"
              )}
            >
              {r.builderRate}
            </td>
            <td
              className={cn(
                "hui-price-grid__cell",
                isTbd(r.humanPayout) && "hui-price-grid__cell--tbd"
              )}
            >
              {r.humanPayout}
            </td>
            <td
              className={cn(
                "hui-price-grid__cell",
                isTbd(r.networkFeePct) && "hui-price-grid__cell--tbd"
              )}
            >
              {r.networkFeePct}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
